import { render, staticRenderFns } from "./BotFrame.vue?vue&type=template&id=5bc24b34&scoped=true&"
import script from "./BotFrame.vue?vue&type=script&lang=js&"
export * from "./BotFrame.vue?vue&type=script&lang=js&"
import style0 from "./BotFrame.vue?vue&type=style&index=0&id=5bc24b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc24b34",
  null
  
)

export default component.exports